module.exports = __webpack_public_path__ + "static/media/ic-exit.91efef7e.svg";